import { IApplicationState } from '../../../../../../types/types';
import { getAsidePanel } from './getAsidePanel';

export const getAsidePanelIsMobile = (
    state: IApplicationState
): boolean => {
    return getAsidePanel(state).isMobile;
};
